export const environment = {
  production: true,
  // 'usePrePath' is set to true when building a website that is installed in a sub directory of web server's 'document root'
  usePrePath: false,
  // 'prePath' is the name of the sub directory that the website is installed in e.g. '/geomodels'
  prePath: '/geomodels'
};
